/**
 * Normalize API fetch failures into user-facing access messages.
 * Used when route guards pass but the API still returns 403 (stale session, etc.).
 */
export function messageFromApiResponse(status, bodyText = '') {
  if (status === 403) {
    try {
      const j = JSON.parse(bodyText)
      if (j?.code === 'MODULE_DISABLED' && j?.error) return j.error
      if (j?.error && j.error !== 'Forbidden') return j.error
    } catch (_) { /* ignore */ }
    return "You don't have permission to access this page."
  }
  if (status === 401) return 'Your session has expired — please log in again.'
  return null
}

export async function readApiAccessMessage(response) {
  const text = await response.text().catch(() => '')
  return messageFromApiResponse(response.status, text) || `Request failed (${response.status})`
}
